(function() {
  var cache = {};
  var pending = {};

  function getProductHandle(url) {
    var anchor = document.createElement('a');
    anchor.href = url;
    var match = anchor.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function createBadge() {
    var badge = document.createElement('span');
    badge.className = 'customize-designer-select-badge';
    badge.setAttribute('aria-label', "Designer's Select");
    badge.innerHTML = '<img class="customize-designer-select-badge__icon" src="' + window.LucceDesignerSelectBadgeIcon + '" alt="" loading="lazy"><span class="customize-designer-select-badge__text">DESIGNER\'S SELECT</span><span class="customize-designer-select-tooltip" role="tooltip"><span>Personally selected diamond by LUCCE Chief Designer and GIA Graduate, Christine.</span></span>';
    return badge;
  }

  function renderBadge(link) {
    if (!link.querySelector('.customize-designer-select-badge')) {
      if (window.getComputedStyle(link).position === 'static') {
        link.style.position = 'relative';
      }
      link.appendChild(createBadge());
    }
  }

  function findBadgeTarget(link) {
    var card = link.closest('.grid-view-item, .spf-product-card, .gf-product, .grid__item, li');
    var imageLink;

    if (!card) {
      return null;
    }

    if (link.querySelector('img')) {
      return link;
    }

    if (card) {
      imageLink = card.querySelector('a[href*="/products/"] img');
      if (imageLink) {
        return imageLink.closest('a');
      }
    }

    return link;
  }

  function fetchBadgeState(handle) {
    if (cache.hasOwnProperty(handle)) {
      return Promise.resolve(cache[handle]);
    }
    if (pending[handle]) {
      return pending[handle];
    }

    pending[handle] = fetch('/products/' + handle + '?view=designers-select-badge', {
      credentials: 'same-origin'
    })
      .then(function(response) {
        return response.ok ? response.text() : 'false';
      })
      .then(function(text) {
        var enabled = text.trim() === 'true';
        cache[handle] = enabled;
        delete pending[handle];
        return enabled;
      })
      .catch(function() {
        cache[handle] = false;
        delete pending[handle];
        return false;
      });

    return pending[handle];
  }

  function updateCards(root) {
    var links = (root || document).querySelectorAll('a[href*="/products/"]');

    links.forEach(function(link) {
      if (link.dataset.designersSelectChecked === 'true') return;

      var handle = getProductHandle(link.href);
      if (!handle) return;

      link.dataset.designersSelectChecked = 'true';
      fetchBadgeState(handle).then(function(enabled) {
        var target;
        if (enabled) {
          target = findBadgeTarget(link);
          if (target) {
            renderBadge(target);
          }
        }
      });
    });
  }

  function scheduleUpdate(root) {
    window.requestAnimationFrame(function() {
      updateCards(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    updateCards(document);

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            scheduleUpdate(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();
